import { http } from '@/core/helpers/http.helper';
import { LocationQuery } from 'vue-router';
import { ApiResource } from '../../models/api-resource.interface';
import { InternalJobFunction } from './internal-job-function.interface';

export class InternalJobFunctionService {
   async getInternalJobFunctions(query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<InternalJobFunction>>>(`/internal-job-functions`, { params: { ...query } });
      return response.data;
   }

   async postInternalJobFunction(internalJobFunction: InternalJobFunction) {
      const response = await http.post<InternalJobFunction>(`/internal-job-functions`, internalJobFunction);
      return response.data;
   }

   async putInternalJobFunction(internalJobFunctionId: number, internalJobFunction: InternalJobFunction) {
      const response = await http.put<InternalJobFunction>(`/internal-job-functions/${internalJobFunctionId}`, internalJobFunction);
      return response.data;
   }

   async deleteInternalJobFunction(internalJobFunctionId: number) {
      const response = await http.delete<void>(`/internal-job-functions/${internalJobFunctionId}`);
      return response.data;
   }
}
